import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

// 超时时间
axios.defaults.timeout = 100000
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
axios.defaults.headers = {'Content-Type': 'application/json; charset=utf-8'}
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
// 非生产环境 && 开启代理, 接口前缀统一使用[/api]前缀做代理拦截!
// const BASE_URL = '/api'
const BASE_URL = process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_SERVER_API
const MATER_URL = process.env.NODE_ENV !== 'production' ? process.env.VUE_APP_MATER1_API : process.env.VUE_APP_MATER_API
// 对面暴露的基础请求路径
axios.BASE_URL = BASE_URL


/**
 * 请求拦截
 */
// 请求头带上token
axios.interceptors.request.use(config => {
    if (config.class && config.class == 'mater') {
        if(Vue.cookie.get('pm-token')){
            config.headers['pm-token'] = 'Bearer ' + Vue.cookie.get('pm-token') // 让每个请求携带自定义token 请根据实际情况自行修改
        }
    } else {
        if(Vue.cookie.get('token')){
            config.headers.token = Vue.cookie.get('token')
        }
    }
    // 请求地址处理
    if (!config.url.startsWith('http')) {
        if (config.class && config.class == 'mater') {
            config.url = MATER_URL + config.url
        } else {
            config.url = BASE_URL + config.url
        }
    }
    const type = config.method
    const arrayFormat = config.headers.arrayFormat || 'indices'
    if (type === 'post' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded; charset=utf-8') {
        // post请求参数处理
        config.data = qs.stringify(config.data, {allowDots: true, arrayFormat: arrayFormat})
    } else if (type === 'get') {
        // get请求参数处理
        config.paramsSerializer = (params) => {
            return qs.stringify(params, {
                allowDots: true, arrayFormat: arrayFormat
            })
        }
    }
    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截
 */
axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.reject(error)
})
export default axios
